export default "__VITE_ASSET__BIhiq2J5__"